import { render } from "./UseinfoCardThumbnail.vue?vue&type=template&id=0bfb6ed6&scoped=true&ts=true"
import script from "./UseinfoCardThumbnail.vue?vue&type=script&lang=ts"
export * from "./UseinfoCardThumbnail.vue?vue&type=script&lang=ts"

import "./UseinfoCardThumbnail.vue?vue&type=style&index=0&id=0bfb6ed6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/vars.autocall.ai/vars.autocall.ai/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bfb6ed6"]])

export default __exports__